import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any, format: string): any {
    // Utilizza il DatePipe di Angular per formattare la data
    try{
      const datePipe = new DatePipe('it-IT');
      return datePipe.transform(value, format);
    }catch (e){
      return String(value).replace(/-/g, '/');
    }
  }
}
